import { module } from "angular";
import angularDragDrop from "angular-drag-drop";
import ngImgCrop from "ng-img-crop-npm";
import assignees from "@gtmhub/assignees/module";
import badges from "@gtmhub/badges/badges.module";
import customFieldsCore from "@gtmhub/customFields/custom-fields-core.module";
import employeesCore from "@gtmhub/employees/employees-core.module";
import errorHandling from "@gtmhub/error-handling/module";
import favorites from "@gtmhub/favorites/favorites.module";
import navigation from "@gtmhub/navigation/navigation.module";
import profile from "@gtmhub/profile/profile.module";
import reflections from "@gtmhub/reflections/reflections.module";
import searchCore from "@gtmhub/search/search-core.module";
import ghAngularDragDrop from "@gtmhub/shared/decorators/angular-drag-drop/angular-drag-drop.decorator";
import usersCore from "@gtmhub/users/users-core.module";
import { AssigneeActiveOkrsListComponent } from "../../../webapp/src/app/okrs/components/assignee-active-okrs-list/assignee-active-okrs-list.component";
import { BaseTeamProfileInfoComponent } from "./components/base-team-info/base-team-info.component";
import { BulkEditTeamMembersComponent } from "./components/bulk-edit-team-members/bulk-edit-team-members.component";
import { OrgChartV3Component } from "./components/org-chart-v3/org-chart-v3.component";
import { TeamProfileComponent } from "./components/team-profile/team-profile.component";
import { TeamFormCtrl } from "./controllers/form";
import { OrganizationChartCtrl } from "./controllers/organization-chart.ctrl";
import { TeamsCtrl } from "./controllers/teams";
import teamsCore from "./teams-core.module";

const mod = module("teams", [
  teamsCore,
  profile,
  usersCore,
  assignees,
  badges,
  errorHandling,
  customFieldsCore,
  employeesCore,
  angularDragDrop,
  ghAngularDragDrop,
  ngImgCrop,
  reflections,
  favorites,
  searchCore,
  navigation,
])
  .component("teamProfile", TeamProfileComponent)
  .component("orgChartV3", OrgChartV3Component)
  .component("baseTeamProfileInfo", BaseTeamProfileInfoComponent)
  .component("bulkEditTeamMembers", BulkEditTeamMembersComponent)
  .controller("TeamsCtrl", TeamsCtrl)
  .controller("OrganizationChartCtrl", OrganizationChartCtrl)
  .controller("TeamFormCtrl", TeamFormCtrl);

mod.downgradeComponent("assigneeActiveOkrsList", { component: AssigneeActiveOkrsListComponent, propagateDigest: false });

export default mod.name;
